import React from 'react';
import classNames from 'classnames';

import ComparisonBaseCell from '@/views/containers/comparison/ComparisonTable/ComparisonBaseCell';
import { FormattedMessageV2 } from '@/views/components/i18n';

const getRowClass = (meta?: RowMeta) =>
  classNames('tax-analysis-table-row', {
    'tax-analysis-table-row-tall': meta?.isTall,
    'tax-analysis-loss-row': meta?.isLossRow,
    'tax-analysis-section-divider': meta?.hasSectionDivider,
  });

const getLabelClass = (meta?: RowMeta) =>
  classNames('tax-analysis-table-label', {
    'tax-analysis-sub-row': meta?.isSubRow,
  });

export type RowMeta = {
  isSubRow?: boolean;
  isLossRow?: boolean;
  hasSectionDivider?: boolean;
  isTall?: boolean;
};

export type Row<T> = {
  key: string;
  label: React.ReactNode;
  cell?: (props: { taxAnalysisData: T }) => React.ReactNode;
  meta?: RowMeta;
};

type ImplicationsSectionProps<T> = {
  captionKey?: string;
  rows: Row<T>[];
  taxAnalysisData: T;
};

function ImplicationsSection<T>({ captionKey, rows, taxAnalysisData }: ImplicationsSectionProps<T>) {
  return (
    <table className="tax-analysis-implications-table">
      {captionKey && (
        <caption className="tax-analysis-table-caption">
          <FormattedMessageV2 toLocalize={captionKey} />
        </caption>
      )}

      <tbody>
        {rows.map(row => (
          <tr key={row.key} className={getRowClass(row.meta)}>
            <td className={getLabelClass(row.meta)}>
              <ComparisonBaseCell>{row.label}</ComparisonBaseCell>
            </td>
            <td className="tax-analysis-table-value">
              <ComparisonBaseCell>{row.cell?.({ taxAnalysisData }) ?? ''}</ComparisonBaseCell>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ImplicationsSection;
